import { useEffect } from 'react';

import { useGetSharedScenarioEvents } from '../queries/useGetSharedScenarioEvents';

export const useSharedScenarioEvents = (shareToken: string) => {
  const {
    refetch: fetchEvents,
    hasNextPage,
    data,
    fetchNextPage,
  } = useGetSharedScenarioEvents(shareToken);

  useEffect(() => {
    if (!hasNextPage) return;

    fetchNextPage();
  }, [hasNextPage, data]);

  return {
    fetchEvents,
    data:
      !hasNextPage && data
        ? data.pages.map((page) => page.content || []).flat()
        : [],
  };
};
